import react from "react";
import { Link } from "react-router-dom";

function Footer() {
    return (
        <div> 
        <hr />
        <footer className="footer_widgets color_three">
            <div className="footer_top">
            <div className="container-fluid">
                <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-7">
                    <div className="widgets_container contact_us">
                    <div className="footer_logo">
                        <a href="/"><img src="/assets/images/fj-logo.png" width='30' height='30' /></a>
                    </div>
                    <p className="footer_desc">Find best things in your area</p>
                    <p><span>Address:</span> Dubai, UAE</p>
                    </div>       
                </div>
                <div className="col-lg-4 col-md-3 col-sm-5">
                    <div className="widgets_container widget_menu">
                    <h3>Information</h3>
                    <div className="footer_menu">
                        <ul>
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/contact"> Contact Us</a></li>
                        <li><a href="#"> Privacy Policy</a></li>
                        <li><a href="#"> Terms &amp; Conditions</a></li>
                        <li><a href="#"> Site Map</a></li>
                        </ul>
                    </div>
                    </div>
                </div>
                
                </div>
            </div>
            </div>
            <div className="footer_bottom">
            <div className="container-fluid">
                <div className="row align-items-center">
                <div className="col-lg-6 col-md-7">
                    <div className="copyright_area">
                    <p>Copyright  © {new Date().getFullYear()}  <a href="/">FindMeJoinMe</a>  . All Rights Reserved.Design by  <a href="/">FindMeJoinMe</a></p>
                    </div>
                </div>    
                </div>
            </div>
            </div>   
        </footer>

        </div>

    );
}

export default Footer;